import React from "react";
import PropTypes from "prop-types";
import "react-resizable/css/styles.css";
import withStyles from "components/with-styles";
import styles from "./styles/timeline-layout.css.js";
import Segment from "./timeline-segment";
import { secondsToPixels } from "./timeline-utils";

const TimelineLayout = ({ type, period, element, displayOnly, onChange, classes }) => {
  const handleSegmentUpdate = currentSegment => {
    onChange({
      ...element,
      segments: element.segments.map(segment => (segment.id === currentSegment.id ? currentSegment : segment)),
    });
  };

  const handleSegmentDelete = currentSegment => {
    onChange({
      ...element,
      segments: element.segments.filter(segment => segment.id !== currentSegment.id),
    });
  };

  return (
    <div className={classes.layout}>
      <div
        className={classes.segment_container}
        style={{ maxWidth: secondsToPixels(period), minWidth: secondsToPixels(period) }}
      >
        {element.showAlways ? (
          <Segment element={element} disabled period={period} />
        ) : (
          element.segments.map(segment => (
            <Segment
              key={segment.id}
              element={element}
              disabled={displayOnly}
              segment={segment}
              onChange={handleSegmentUpdate}
              period={period}
              onDelete={handleSegmentDelete}
            />
          ))
        )}
      </div>
    </div>
  );
};

TimelineLayout.propTypes = {
  /*
   * Elemento a representar en el timeline
   */
  element: PropTypes.shape({
    layoutId: PropTypes.string.isRequired,
    showAlways: PropTypes.bool.isRequired,
    name: PropTypes.string.isRequired,
    segments: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        start: PropTypes.number,
        end: PropTypes.number,
      }),
    ),
  }),
  /*
   * Indica si está oculta la edición
   */
  displayOnly: PropTypes.bool,
  /*
   * Callback que se llama con el elemento actualizado
   */
  onChange: PropTypes.func,
  /*
   * Período que representa el timeline (en segundos)
   */
  period: PropTypes.number,
  /*
   * Tipo de schedule
   */
  type: PropTypes.string,
};

export default withStyles(styles)(TimelineLayout);
